import { render, staticRenderFns } from "./PDFClientPartsProtocol.vue?vue&type=template&id=0440fce2&scoped=true&"
import script from "./PDFClientPartsProtocol.vue?vue&type=script&lang=js&"
export * from "./PDFClientPartsProtocol.vue?vue&type=script&lang=js&"
import style0 from "./PDFClientPartsProtocol.vue?vue&type=style&index=0&id=0440fce2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0440fce2",
  null
  
)

export default component.exports